// 英文译文 · 财务:收付款管理(银行账户 / 收款 / 付款 / 平台结算)· 退款申请 · 财务报表 · 经营报表 · key = 代码里的中文原文,一字不差
export default {
  // ── 收付款管理 · 平台结算同步 ──
  "最近同步 {ts}(UTC)": "Last synced {ts} (UTC)",
  "还没同步过": "Never synced",
  "{account}:打款 {fetched} 笔(新 {new})· 明细 {lines} 条 · 对上 {matched} / 未对上 {unmatched}": "{account}: {fetched} payouts ({new} new) · {lines} lines · {matched} matched / {unmatched} unmatched",
  "生成收款单 {n} 张": "{n} receipts generated",
  "⚠ 未设结算到账账户,没生成收款单": "⚠ No payout bank account set, no receipts generated",
  "{account}:失败 {error}": "{account}: failed · {error}",
  "没有可同步的店铺": "No stores to sync",
  "同步结果": "Sync Results",
  // ── 收付款管理 · 状态 ──
  "未对账": "Unmatched",
  "已对账": "Matched",
  "有差异": "Discrepancy",
  "待审批": "Pending Approval",
  // ── 收付款管理 · 提示 ──
  "归档账户 {code}?": "Archive account {code}?",
  "付款方名称必填": "Payer name is required",
  "入账银行账户必选": "Please select the receiving bank account",
  "已建 {no}": "Created {no}",
  "作废收款 {no}?": "Void receipt {no}?",
  "收款方名称必填": "Payee name is required",
  "出账银行账户必选": "Please select the paying bank account",
  "审批通过 · 备注": "Approve · Comment",
  "审批": "Approval",
  "可留空": "Optional",
  "需要另一位管理员审批 · 提交人不可自审": "Another admin must approve · Submitters cannot approve their own requests",
  "付款日期 / 银行流水号必填": "Payment date / bank reference no. are required",
  "已标记已付": "Marked as paid",
  "作废付款 {no}?": "Void payment {no}?",
  // ── 收付款管理 · 银行账户 ──
  "银行账户": "Bank Accounts",
  "平台结算": "Platform Payout",
  "全部币": "All currencies",
  "+ 新建银行账户": "+ New Bank Account",
  "银行": "Bank",
  "开户名": "Account Name",
  "账号末 4": "Last 4 Digits",
  "进": "In",
  "出": "Out",
  "编辑银行账户": "Edit Bank Account",
  "新建银行账户": "New Bank Account",
  "账户编号": "Account Code",
  "汇丰港币主账": "HSBC HKD main account",
  "支行": "Branch",
  "默认进账": "Default for Incoming",
  "默认出账": "Default for Outgoing",
  // ── 收付款管理 · 收款 ──
  "收款记录": "Receipts",
  "客户回款": "Customer Payment",
  "内部结算": "Internal Settlement",
  "其他": "Other",
  "+ 新建收款": "+ New Receipt",
  "收款单号": "Receipt No.",
  "到账日": "Received Date",
  "付款方": "Payer",
  "入账账户": "Receiving Account",
  "流水号": "Bank Ref No.",
  "对账": "Reconcile",
  "新建收款": "New Receipt",
  "平台 key": "Platform Key",
  "结算批次号": "Payout Batch No.",
  "付款方名称": "Payer Name",
  "入账银行账户": "Receiving Bank Account",
  "选账户": "Select account",
  "关联销售单 ID": "Linked Sales Order ID",
  "收款对账": "Reconcile Receipt",
  "对账结果": "Reconciliation Result",
  "已对账 · 匹配": "Matched",
  "差异说明": "Discrepancy Note",
  // ── 收付款管理 · 付款 ──
  "付款记录": "Payments",
  "用途": "Purpose",
  "供应商货款": "Supplier Payment",
  "费用付款": "Expense Payment",
  "+ 新建付款": "+ New Payment",
  "付款单号": "Payment No.",
  "付款日": "Payment Date",
  "审批通过": "Approve",
  "待 {name} 审批": "Awaiting approval by {name}",
  "标记已付": "Mark Paid",
  "新建付款": "New Payment",
  "关联采购单 ID": "Linked Purchase Order ID",
  "费用申请 ID": "Expense Request ID",
  "收款方名称": "Payee Name",
  "出账银行账户": "Paying Bank Account",
  "计划付款日": "Planned Payment Date",
  "付款日期": "Payment Date",
  "银行流水号": "Bank Ref No.",
  // ── 收付款管理 · 平台结算(Shopify 打款)──
  "平台结算(Shopify 打款)": "Platform Payout (Shopify Payouts)",
  "同步打款(近 90 天)": "Sync Payouts (Last 90 Days)",
  "每次打款 = 一笔「平台结算」收款,金额是": "Each payout = one \"Platform Payout\" receipt; the amount is what was ",
  "实际到账": "actually received",
  "的钱(平台已扣手续费、退款)。": " (after the platform has deducted fees and refunds).",
  "打款币种可能跟订单币种不同(香港店收 EUR / USD,平台换成 HKD 打款),ERP 记到账金额,订单原币金额仍在销售单上。": "The payout currency may differ from the order currency (e.g. a Hong Kong store charges EUR / USD and the platform pays out in HKD). The ERP records the amount received; the original order amount stays on the sales order.",
  "打开这个页签会自动同步一次(离上次不到 1 小时则跳过),后台每 3 小时也会自动同步;要立刻拉更早的数据点右上角按钮。": "Opening this tab syncs once automatically (skipped if the last sync was less than 1 hour ago), and the server also syncs every 3 hours. To pull older data right away, use the button at the top right.",
  "店铺「{label}」还没设结算到账银行账户 · 打款只记录、不生成收款单 · 去「外部平台 → 编辑」里设": "Store \"{label}\" has no payout bank account · Payouts are recorded but no receipts are generated · Set it under \"External Platforms → Edit\"",
  "店铺": "Store",
  "打款单号": "Payout No.",
  "到账金额": "Amount Received",
  "订单收款": "Order Charges",
  "手续费": "Fee",
  "{n} 条": "{n} lines",
  "{n} 条没对上": "{n} unmatched",
  "收款单": "Receipt",
  "未生成": "Not generated",
  "打款 {ref} · {date} · {currency} {amount}": "Payout {ref} · {date} · {currency} {amount}",
  "打款明细": "Payout Details",
  "平台订单": "Platform Order",
  "ERP 销售单": "ERP Sales Order",
  "⚠ ERP 里没有这单": "⚠ Not in ERP",
  "订单金额": "Order Amount",
  "发生时间": "Processed at",
  // 后端 payouts.py STATUS_CN / TYPE_CN(status_cn / type_cn 显示时 tr)
  "已到账": "Received",
  "在途": "In Transit",
  "已排期": "Scheduled",
  "失败": "Failed",
  "拒付": "Chargeback",
  "打款": "Payout",
  // ── 退款申请 ──
  "退款中": "Refunding",
  "已退款": "Refunded",
  "请填退款原因": "Please enter a refund reason",
  "金额必须 > 0": "Amount must be > 0",
  "已提交 · 等另一位管理员审批": "Submitted · Waiting for another admin to approve",
  "已审批通过": "Approved",
  "驳回原因": "Rejection reason",
  "驳回原因必填": "Rejection reason is required",
  "需要另一位管理员操作 · 提交人不可自驳": "Another admin must do this · Submitters cannot reject their own requests",
  "填银行/平台退款回执号": "Enter the bank / platform refund reference no.",
  "标记已退款": "Mark as Refunded",
  "确认已退": "Confirm Refunded",
  "回执号必填": "Reference no. is required",
  "已标记已退款": "Marked as refunded",
  "取消退款申请 {no}?": "Cancel refund request {no}?",
  "客户/平台/运费退款 · 一审工作流": "Customer / platform / freight refunds · Single-step review workflow",
  "全部来源": "All sources",
  "+ 新建退款申请": "+ New Refund Request",
  "原因": "Reason",
  "退款方式": "Refund Method",
  "平台/关联": "Platform / Links",
  "提交一审": "Submit for Review",
  "一审通过": "Approve",
  "标记已退": "Mark Refunded",
  "编辑退款申请": "Edit Refund Request",
  "新建退款申请": "New Refund Request",
  "客户 ID(选填)": "Customer ID (optional)",
  "customer_refund 时常用 · 关联到具体客户": "Typical for customer_refund · Links to a specific customer",
  "关联收款 ID": "Linked Receipt ID",
  "退款原因": "Refund Reason",
  "退款申请详情": "Refund Request Details",
  "客户 ID": "Customer ID",
  "关联 SO": "Linked SO",
  "关联 RCV": "Linked RCV",
  "回执号": "Reference No.",
  "审批时间": "Approved at",
  "审批意见": "Approval Comment",
  "已退款时间": "Refunded at",
  // api/finance.ts REFUND_SOURCE_TYPES / REFUND_METHODS(显示时 tr)
  "客户退款": "Customer Refund",
  "平台退款": "Platform Refund",
  "运费调整": "Freight Adjustment",
  "银行转账": "Bank Transfer",
  "平台原路退款": "Refund via Platform (Original Method)",
  "钱包/账户": "Wallet / Account",
  // ── 财务报表 ──
  "未逾期": "Current",
  "逾期 1-30 天": "1-30 Days Overdue",
  "逾期 31-60 天": "31-60 Days Overdue",
  "逾期 61-90 天": "61-90 Days Overdue",
  "逾期 > 90 天": "> 90 Days Overdue",
  "经营报表(权责发生制)· 资金收支(收付实现制)· 应收/应付 · 现金流 · 按币种自适应": "Operating Report (Accrual Basis) · Cash Flow (Cash Basis) · Receivable / Payable · Daily Cash Flow · Per currency",
  "经营报表(权责发生制)": "Operating Report (Accrual Basis)",
  "资金收支(收付实现制)": "Cash Flow (Cash Basis)",
  "应收账款": "Accounts Receivable",
  "应付账款": "Accounts Payable",
  "现金流": "Daily Cash Flow",
  "资金收支 · {month}": "Cash Flow · {month}",
  "收付实现制:按到账 / 付款日期": "Cash basis: by received / payment date",
  "主币种": "Main currency",
  "收入": "Revenue",
  "{n} 笔": "{n} transactions",
  "支出(已付款)": "Expenditure (Paid)",
  "已批未付": "Approved, Unpaid",
  "净利": "Net Profit",
  "本月无流水": "No transactions this month",
  "全部币种": "All Currencies",
  "支出": "Expenditure",
  "应收": "Receivable",
  "{n} 张": "{n} invoices",
  "暂无未收全款的已开销售发票": "No issued sales invoices with an outstanding balance",
  "账龄分布": "Aging Distribution",
  "账龄区间": "Aging Bucket",
  "张数": "Invoices",
  "金额(合计)": "Amount (Total)",
  "TOP 10 债务客户": "Top 10 Debtors",
  "应付": "Payable",
  "暂无未付全款的已收供应商发票": "No received supplier invoices with an outstanding balance",
  "TOP 10 债权供应商": "Top 10 Creditors",
  "现金流 · 近 {n} 天": "Daily Cash Flow · Last {n} Days",
  "近 {n} 天": "Last {n} days",
  "近 {n} 天无现金流": "No cash flow in the last {n} days",
  "日期": "Date",
  "累计": "Cumulative",
  // ── 经营报表 · 权责发生制 ──
  "上月 0": "Last month: 0",
  "{arrow} {pct}% vs 上月": "{arrow} {pct}% vs last month",
  "分类、说明、金额(大于 0)必填": "Category, description and amount (> 0) are required",
  "已修改": "Updated",
  "已补录到 {month}": "Recorded under {month}",
  "作废补录「{title}」{currency} {amount}?作废后不再计入费用,记录保留。": "Void manual entry \"{title}\" {currency} {amount}? Once voided it no longer counts as an expense; the record is kept.",
  "作废补录": "Void Manual Entry",
  "作废原因(必填)": "Void reason (required)",
  "请写原因": "Please enter a reason",
  "经营报表 · {month}": "Operating Report · {month}",
  "+ 费用补录": "+ Manual Expense Entry",
  "权责发生制": "Accrual Basis",
  "收入 = 本月发货的订单(没开票也算,已取消不算)": "Revenue = orders shipped this month (counted even if not invoiced; cancelled orders excluded)",
  "退款 = 本月退款完成的,冲减本月收入": "Refunds = refunds completed this month, deducted from this month's revenue",
  "费用 = 所属月份是本月的费用申请(已审批 / 已付款)+ 费用补录": "Expenses = expense requests whose expense month is this month (approved / paid) + manual expense entries",
  "成本暂未核算": "Cost not yet calculated",
  "本月还有 {n} 张费用申请待审批({currency} {amount}),审批通过后才计入": "{n} expense requests this month are still pending approval ({currency} {amount}); they count only once approved",
  "本月没有发货、退款和费用": "No shipments, refunds or expenses this month",
  "销售额(已发货)": "Sales (Shipped)",
  "{n} 单 · 客单 {avg}": "{n} orders · Avg. order {avg}",
  "退款(冲减)": "Refunds (Deducted)",
  "净收入": "Net Revenue",
  "待成本核算": "Pending cost calculation",
  "申请 {req} · 补录 {manual}": "Requests {req} · Manual {manual}",
  "利润(未扣成本)": "Profit (Before Cost)",
  "销售额": "Sales",
  "单数": "Orders",
  "费用分类": "Expense Category",
  "收入明细 · 本月发货 {n} 单": "Revenue Details · {n} orders shipped this month",
  "订单号": "Order No.",
  "平台单号": "Platform Order No.",
  "发货日": "Ship Date",
  "发货日来源": "Ship Date Source",
  "退款明细 · {n} 笔": "Refund Details · {n} refunds",
  "退款单号": "Refund No.",
  "退款完成": "Refunded at",
  "费用明细 · {n} 笔(费用申请 + 补录)": "Expense Details · {n} items (expense requests + manual entries)",
  "说明": "Description",
  "费用补录 · {n} 笔(报销、线下支出 · 不走审批)": "Manual Expense Entries · {n} items (reimbursements, offline spending · no approval)",
  "已经走过费用申请的不要重复补录。作废后不再计入费用,记录保留。": "Don't re-enter anything that already went through an expense request. Voided entries no longer count as expenses; the record is kept.",
  "所属月份": "Expense Month",
  "支付日": "Paid Date",
  "录入": "Entered By",
  "编辑费用补录": "Edit Manual Expense Entry",
  "费用补录": "Manual Expense Entry",
  "选择分类": "Select category",
  "比如:9 月快递费报销": "e.g. September courier fee reimbursement",
  "可不填": "Optional",
  "支付日期": "Payment Date",
  // 后端 operating_report.py CHANNEL_CN / SOURCE_CN / 费用来源(显示时 tr)
  "独立站": "Independent Site",
  "发货单": "Shipment",
  "平台发货时间": "Platform ship time",
  "订单转已发货": "Order marked shipped",
  "补录": "Manual Entry",
  // 费用分类(后端 expenses.py CATEGORY_CN = api/finance.ts EXPENSE_CATEGORY_GROUPS · 显示时 tr)
  "人事": "Personnel",
  "场地办公": "Premises & Office",
  "财税与服务": "Tax, Finance & Services",
  "工资": "Salaries",
  "社保": "Social Insurance",
  "福利费": "Employee Benefits",
  "餐费": "Meals",
  "人力资源": "Human Resources",
  "房租水电费": "Rent & Utilities",
  "停车费": "Parking",
  "办公": "Office Expenses",
  "差旅": "Travel",
  "招待": "Entertainment",
  "市场推广": "Marketing",
  "电商运营": "E-commerce Operations",
  "物流": "Logistics",
  "税费": "Taxes & Duties",
  "财务费用": "Finance Costs",
  "咨询费": "Consulting Fees",
  "专业服务": "Professional Services",
  "IT / 软件": "IT / Software",
  // 2026-09-27 经营报表 · 成本核算
  "汇率已保存": "Exchange rates saved",
  "请填标准运费": "Please enter the standard freight",
  "已保存 {code} 的标准运费": "Standard freight saved for {code}",
  "供货价取自": "Supply price from",
  "有哪家用哪家": "Any supplier",
  "汇率": "Exchange Rates",
  "+ 成本补录": "+ Manual Cost",
  "成本 = 供货价 × 发货数量 + 标准运费 × 发货数量 + 成本补录(模具费等)": "Cost = supply price × shipped qty + standard freight × shipped qty + manual costs (molds, etc.)",
  "按每月汇率折人民币算利润": "Profit is computed in CNY at the monthly exchange rate",
  "合计 · 折人民币": "Total · in CNY",
  "沿用 {month}": "carried over from {month}",
  "缺 {ccys} 汇率,算不出人民币合计": "Missing {ccys} exchange rate — cannot compute the CNY total",
  "录汇率": "Enter rates",
  "供货 {goods} · 运费 {freight} · 模具等 {manual}": "Goods {goods} · Freight {freight} · Molds etc. {manual}",
  "毛利": "Gross Profit",
  "毛利率 {pct}%": "Gross margin {pct}%",
  "利润": "Profit",
  "成本(原币)": "Cost (orig. ccy)",
  "供货": "Goods",
  "运费": "Freight",
  "运费发票": "Freight invoice",
  "实际运费": "Actual freight",
  "FBA · 头程另计": "FBA · inbound freight separate",
  "成本补录": "Manual Cost",
  "成本明细 · {n} 行": "Cost details · {n} lines",
  "供货单价": "Supply Unit Price",
  "缺": "Missing",
  "估算": "Est.",
  "供货成本": "Goods Cost",
  "标准运费": "Std. Freight",
  "缺数据 · {n} 项(补齐成本才准)": "Missing data · {n} items (fill in for accurate cost)",
  "没填标准运费(每件)": "No standard freight (per unit)",
  "本月发货": "Shipped this month",
  "标准运费(每件)": "Standard Freight (per unit)",
  "没有供货价": "No supply price",
  "去录来货价 →": "Enter supply prices →",
  "产品库里找不到的 SKU": "SKUs not found in the product library",
  "成本补录 · {n} 笔(模具费等 · 发生当月计入)": "Manual costs · {n} (molds etc. · counted in the month incurred)",
  "编辑成本补录": "Edit Manual Cost",
  "比如:XX 产品开模费": "e.g. mold fee for product XX",
  "汇率 · {month}": "Exchange Rates · {month}",
  "1 外币 = ? 人民币 · 本月没录的沿用之前最近一个月 · 清空 = 删掉本月这条": "1 foreign unit = ? CNY · months without a rate reuse the latest earlier month · clear = delete this month's rate",
  "+ 加币种": "+ Add currency",
  "经营报表算成本用:标准运费 × 发货数量": "Used for operating-report cost: standard freight × shipped qty",
  "作废补录「{title}」{currency} {amount}?作废后不再计入成本,记录保留。": "Void manual entry \"{title}\" {currency} {amount}? It will no longer count as cost; the record is kept.",
  "模具费": "Mold Fees",
  "货款": "Goods Payment",
  "其他成本": "Other Costs",
  "全部渠道": "All channels",
  "产品库没有": "Not in products",
  "{n} 件没金额": "{n} units without amount",
  // 2026-10-14 经营报表改版
  "经营报表": "Operating Report",
  "口径说明": "How it's calculated",
  "渠道、店铺 / 客户都按本公司自己的单认:平台单按店铺,集团内的单和客户单按客户;筛选时费用和成本补录分不到店铺 / 客户,不算": "Channel and store / customer follow this company's own orders: platform orders by store, intra-group and customer orders by customer; when filtering, expenses and cost entries can't be split by store / customer and are left out",
  "按店铺 / 客户": "By store / customer",
  "店铺 / 客户": "Store / customer",
  "全部店铺 / 客户": "All stores / customers",
  "补录记录({n})": "Manual entries ({n})",
  "补录记录 · {month}": "Manual entries · {month}",
  "有 {n} 项成本数据缺失": "{n} cost data items missing",
  "还有 {n} 条": "{n} more",
  "去补数据({n})": "Fix data ({n})",
  "这个渠道 / 店铺本月没有发货和退款": "No shipments or refunds for this channel / store this month",
  "销售额 {s} · 退款 −{r}": "Sales {s} · refunds −{r}",
  "订单数": "Orders",
  "客单 {avg}": "Avg order {avg}",
  "销量(件)": "Units sold",
  "筛选时不算(费用不分店铺)": "Not counted when filtered (expenses aren't per store)",
  "筛选时看毛利": "Use gross profit when filtered",
  "人民币 · 跟 {month} 比": "CNY · compared with {month}",
  "按渠道": "By channel",
  "按店铺": "By store",
  "按产品": "By product",
  "明细@@报表": "Details",
  "销售额 = 订单行金额,不含运费和整单折扣 · 退款分不到产品,不扣": "Sales = order line amounts, excluding shipping and order-level discounts · refunds can't be split by product and are not deducted",
  "净收入 = 订单金额 − 关联到订单的退款 · 成本 = 供货 + 运费": "Net revenue = order amount − refunds linked to the order · cost = goods + freight",
  "件数": "Units",
  "销售额(原币)": "Sales (original currency)",
  "净收入 ¥": "Net revenue ¥",
  "成本 ¥": "Cost ¥",
  "成本不全": "Cost incomplete",
  "毛利 ¥": "Gross profit ¥",
  "毛利率": "Gross margin",
  "收入 · {n} 单": "Revenue · {n} orders",
  "成本 · {n} 行": "Cost · {n} lines",
  "退款 · {n} 笔": "Refunds · {n}",
  "费用 · {n} 笔": "Expenses · {n}",
  "按币种": "By currency",
  "筛选渠道 / 店铺时费用不算(费用不分店铺)· 清掉筛选才看得到": "Expenses are not counted when filtering by channel / store (they aren't per store) · clear the filter to see them",
  "没有缺的": "Nothing missing",
  "成本不全,毛利偏高": "Cost incomplete, gross profit overstated",
  "查看 / 录入汇率": "View / enter rates",
  "销售额 ¥": "Sales ¥",
  // 2026-10-17 付款单详情 / 删除作废单
  "删除已作废的付款单 {no}?删了就没了(审计日志里留一份)。": "Delete voided payment {no}? It will be gone (a copy stays in the audit log).",
  "显示已作废的": "Show voided",
  "付款单 {no}": "Payment {no}",
  "付的发票 · {n} 张": "Invoices paid · {n}",
  "开票日": "Invoice date",
  "本单付": "Paid here",
  "作废时已解除发票关联": "Invoice links were released when it was voided",
  "没有挂发票": "No invoices attached",
  "(明细见下表)": " (see the table below)",
  "匹配 {n} 张 · 合计 {amt}": "{n} matching · total {amt}",
  "搜发票号 / 采购单 / 平台单号 / 日期": "Search invoice / PO / platform order / date",
  "没有匹配的发票": "No matching invoices",
  // 2026-10-20 收付款下载 Excel
  "ERP 不单独记银行流水和余额:流水 = 到账到这个账户的收款单(没作废)+ 从这个账户付出的付款单(已付款),按日期排,算期间收入、支出和累计净额(没有期初余额)。": "ERP doesn't keep a separate bank ledger or balance: the statement = receipts into this account (not voided) + payments made from it (paid), sorted by date, with in, out and running net for the period (no opening balance).",
  "下载账单 Excel": "Download statement (Excel)",
  "下载银行流水 · {name}": "Download bank statement · {name}",
  "付款单": "Payments",
  "付款账单": "Payment statement",
  "导出 Excel(汇总 + 明细)": "Export Excel (summary + details)",
  "收款账单": "Receipt statement",
  "账单": "Statement",
  "银行流水": "Bank statement",
  "下载付款流水": "Download payments",
  "下载收款流水": "Download receipts",
  "下载账单": "Download statements",
  "先勾要下载账单的单子": "Select the documents to download statements for",
  "导出打款明细": "Export payout details",
  "导出打款汇总": "Export payout summary",
  "平台结算明细": "Payout details",
  "平台结算汇总": "Payout summary",
  "收款流水、付款流水分两个文件下。ERP 不单独记银行流水和余额:收款 = 到账到这个账户的收款单(没作废),付款 = 从这个账户付出的付款单(已付款),没有期初余额。": "Receipts and payments download as two files. ERP doesn't keep a separate bank ledger or balance: receipts = receipts into this account (not voided), payments = payments made from it (paid); no opening balance.",
  "银行付款流水": "Bank payments",
  "银行收款流水": "Bank receipts",
} as Record<string, string>;
